<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="37" viewBox="0 0 16 37">
        <text class="a" transform="translate(8 29)" :fill="this.$vuetify.theme.dark ? '#CECECE' : '#383935'" style="font-size:35px;">
            <tspan x="-7.549" y="0">?</tspan>
        </text>
    </svg>
</template>

<script>
export default {
  name: 'QuestionMark'
}
</script>

<style scoped>
    svg {
        width:16px;
        height: 37px;
    }
</style>